import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const VendorsPage = () => {
    const columns = [
        { key: 'name', label: 'Vendor Name', type: 'text', required: true },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "vendors", title: "Vendors", columns: columns, apiPath: "vendors" }));
};
export default VendorsPage;
